import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { useRoute } from 'vue-router'
import { computed } from 'vue'
import { useStore } from 'vuex'
import { ArrowLeftBold } from '@element-plus/icons-vue'
import ToolBar from '@/components/bussiness/ToolBar.vue'
import sidebar from '@/components/user/Sidebar.vue'
import Extension from '@/components/common/Extension.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const curShop = computed(() => store.state.route.curShop)

const route = useRoute()
const name = computed(() => route.name)
const keepAlive = computed(() => route.meta?.keepAlive)

const showBack = computed(() => route.meta?.showBack)

const layoutClass = computed(() => {
  const layout = route.meta?.layout && route.meta?.layout + '-layout'
  return ['rel', 'flex', 'default-layout', layout]
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ToolBar, { class: "tool-bar" }),
    _createElementVNode("div", {
      class: _normalizeClass([_unref(layoutClass), "fx-1"]),
      style: {"height":"unset","overflow":"hidden"}
    }, [
      _createVNode(sidebar, { key: _unref(curShop) }),
      _createVNode(_component_el_scrollbar, {
        class: _normalizeClass(["fx-1 user-scroll-container", _unref(route).name])
      }, {
        default: _withCtx(() => [
          _createElementVNode("section", {
            class: _normalizeClass(["usecenter-pannel", [{padding0:(_unref(route).path.includes('/vip/VipLevel')), 'min-height': (_unref(route).path.includes('/product/CreateAssociated'))},'fx-1']])
          }, [
            (_unref(showBack))
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  circle: "",
                  icon: _unref(ArrowLeftBold),
                  style: {"margin":"auto auto 10px 10px"},
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true),
            _createVNode(_component_router_view, null, {
              default: _withCtx(({ Component }) => [
                (_openBlock(), _createBlock(_KeepAlive, null, [
                  (_unref(keepAlive))
                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { key: _unref(name) }))
                    : _createCommentVNode("", true)
                ], 1024)),
                (!_unref(keepAlive))
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { key: _unref(name) }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ], 2)
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(Extension)
    ], 2)
  ], 64))
}
}

})